import React from "react";
import "./loaderView.css";

export function TableLoader(props) {
  const { colSpan, loading } = props;
  return (
    <tbody>
      <tr>
        <th colSpan={colSpan || 1} aria-label="loader">
          <Loader loading={loading} />
        </th>
      </tr>
    </tbody>
  );
}
export function Loader(props) {
  const { loading } = props;
  if (loading) {
    return (
      <div className="loader-container">
        <div className="md-preloader">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            height="50"
            width="50"
            viewBox="0 0 50 50"
          >
            <circle cx="25" cy="25" r="21" strokeWidth="6" />
          </svg>
        </div>
      </div>
    );
  }
  return null;
}
